import { SizeStyles, VariantStyles, WithChildrenProps } from '@/types/core-types'
import log from 'loglevel'
import { ComponentProps, PropsWithChildren, useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'

type ButtonProps = {} & WithChildrenProps<'button'>
function Button({ children, className, size: _size, variant: _variant, type: _buttonType, ...props }: ButtonProps) {
  const [size] = useState(_size ?? 'md')
  const [variant] = useState(_variant ?? 'primary')
  const BUTTON_VARIANTS: VariantStyles = {
    primary: 'bg-primary ring-primary hover:bg-primary/80 text-white',
    neutral: 'bg-gray-300 ring-gray-300 hover:bg-gray-300/80 text-black',
    secondary: 'bg-secondary text-black',
    success: 'bg-success text-black',
    warning: 'bg-warning text-black',
    danger: 'bg-red-500 hover:bg-red-600 text-white',
    outline: 'border border-gray-300 text-gray-900 hover:bg-gray-100',
  }
  const SIZE_VARIANTS: SizeStyles = {
    sm: 'text-xs py-1 px-2',
    md: 'text-sm py-2 px-3',
    lg: 'text-base py-3 px-4',
  }

  const baseStyles = twMerge(
    'rounded-md uppercase w-min-20 bg-white px-2 py-1 text-base text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-all duration-200',
    BUTTON_VARIANTS[variant],
    SIZE_VARIANTS[size],
    props.disabled == true && 'bg-gray-300 ring-gray-300 hover:bg-gray-400 text-black cursor-not-allowed',
    className,
  )
  return (
    <button type={_buttonType ?? 'button'} {...props} className={baseStyles}>
      {children}
    </button>
  )
}

export default Button
